import { get } from "radash";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import RegistrationContainer from "src/containers/RegistrationPage";
import { useQuery } from "src/services/utils";

import GenericRegistration from "@containers/RegistrationFlow/GenericRegistration";
import NoEmailAuthRegistration from "@containers/RegistrationFlow/NoEmailAuthRegistration";
import Registration from "@containers/RegistrationFlow/Registration";

const Register = () => {
  const [noAvailability, setNoAvailability] = useState<null | boolean>(false);
  const [initialData, setInitialData] = useState<object>({});

  const history = useHistory();
  const noEmailAuthRegistration = get(
    history,
    "location.state.noEmailAuthRegistration",
  );

  const verifyIdentity = useQuery().get("step") === "identity";
  if (verifyIdentity) return <RegistrationContainer />;

  if (noAvailability) return <GenericRegistration initialData={initialData} />;
  else if (noEmailAuthRegistration)
    return (
      <NoEmailAuthRegistration
        setInitialData={(data) => setInitialData(data)}
      />
    );

  return (
    <Registration
      setInitialData={(data) => setInitialData(data)}
      handleNoAvailability={() => setNoAvailability(true)}
    />
  );
};

export default Register;
